import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { useBilling } from "../context/BillingContext";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function BillingSuccess() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const { refresh } = useBilling();
  const [state, setState] = useState("checking"); // checking | done | timeout
  const tries = useRef(0);

  useEffect(() => {
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/", { replace: true }); return; }
    let active = true;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/verify/${sessionId}`);
        if (!active) return;
        if (data.complete || data.subscription_status === "active" || data.subscription_status === "trialing") {
          await refresh();
          setState("done");
          setTimeout(() => navigate("/", { replace: true }), 1200);
          return;
        }
      } catch (e) { /* keep polling */ }
      tries.current += 1;
      if (tries.current >= 8) { setState("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { active = false; };
  }, [params, navigate, refresh]);

  return (
    <div className="df-shell min-h-screen flex flex-col items-center justify-center px-6 text-center">
      {state === "done" ? (
        <>
          <CheckCircle2 size={56} className="text-[#0D786A] mb-4" />
          <h1 className="text-2xl font-bold text-slate-900" data-testid="billing-success">Subscription active</h1>
          <p className="text-slate-500 mt-1">Taking you back to Molaroo…</p>
        </>
      ) : state === "timeout" ? (
        <>
          <h1 className="text-2xl font-bold text-slate-900">Almost there</h1>
          <p className="text-slate-500 mt-1 mb-5">Your payment is processing. It can take a moment to confirm.</p>
          <button onClick={() => navigate("/", { replace: true })} className="text-[#0D786A] font-semibold df-pressable">Continue to app</button>
        </>
      ) : (
        <>
          <Loader2 size={44} className="text-[#0D786A] mb-4 animate-spin" />
          <h1 className="text-2xl font-bold text-slate-900">Confirming your subscription…</h1>
          <p className="text-slate-500 mt-1">Just a second.</p>
        </>
      )}
    </div>
  );
}
